import React from 'react'

const LoanDocuments = () => {
  return (
    <div>LoanDocuments</div>
  )
}

export default LoanDocuments